// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"05d7eaeb","345":"4c1471fe","375":"babff449","435":"2536b757","787":"d54b2ca0"}[chunkId] + ".chunk.js";
};